import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"

/** When attachments are loading in LCT forms */
const DeviceAttachmentAccordionSkeleton = (): ReactElement => (
    <Stack
        direction="row"
        width="100%"
        spacing={1.5}
        sx={{ pr: 1 }}
        alignItems="center"
    >
        <AppSkeleton width={290} height={40} />
        <AppSkeleton variant="text" height={10} sx={{ flexGrow: 1 }} />
        <AppSkeleton width={25} height={25} />
    </Stack>
)

export default DeviceAttachmentAccordionSkeleton
